"use client";

import type { HeroCta } from "@/components/landing/types";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import DashedFlightPathSvg from "@/components/landing/FinalCta/svg/DashedFlightPathSvg";
import { MotionReveal, useSectionMotion } from "@/components/landing/shared";
import { Icon } from "@/components/ui/Icon";
import { Link } from "@/i18n/navigation";

interface FinalCtaInnerProps {
	title: string;
	body: string;
	cta: HeroCta;
}

function FinalCtaInner(prop: FinalCtaInnerProps) {
	const { title, body, cta } = prop;
	const motion = useSectionMotion();
	return (
		<MotionReveal motion={motion}>
			<div
				className="relative mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 overflow-hidden rounded-[1.75rem] p-8 shadow-[var(--shadow)] sm:p-10 md:flex-row md:items-center"
				style={{
					background: "linear-gradient(115deg, var(--brand-1), var(--brand-2))",
				}}
			>
				<div className="relative z-10">
					<h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{title}</h2>
					<p className="mt-1.5 max-w-xl text-sm text-white/80 sm:text-base">{body}</p>
				</div>

				<div className="relative z-10 flex shrink-0 items-center gap-4">
					<Link
						href={cta.href}
						className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-semibold text-[var(--brand-1)] shadow-sm transition-transform hover:-translate-y-0.5"
					>
						{cta.label}
						<Icon icon={faChevronRight} className="h-4 w-4" />
					</Link>

					<DashedFlightPathSvg className="hidden h-14 w-20 text-white/70 sm:block rtl:-scale-x-100" />
				</div>
			</div>
		</MotionReveal>
	);
}

export default FinalCtaInner;
